module.exports = __webpack_public_path__ + "static/media/video-camera.59517598.svg";